export default "__VITE_ASSET__BeHaVLJZ__"